module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('p', {
    staticClass: "chap-title paracenter",
    staticStyle: {
      "margin-top": "3em"
    },
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/08_contents#ack"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGEMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/acknowledgements-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_vm._v("MY principal acknowledgement must be to Major General Ray Pett, Colonel of the Regiment, for entrusting to me this chronicle of the 6th Gurkhas from their founding year in 1817 until their amalgamation with the 2nd Goorkhas in 1994, to form the First Battalion of The Royal Gurkha Rifles. Since we had never previously met, I am afraid he had to take me very much on trust and I hope I have not let him or the Regiment down. I have done my best to follow the remit he gave me.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("He told me that he did not want the conventional kind of regimental history in which the movements of Companies, and sometimes of Platoons, are recounted in considerable detail, accompanied by maps liberally spattered with arrows pointing this way and that, but rather an overall account of the Regiment from its first raising until its disappearance from the "), _c('em', [_vm._v("Army List")]), _vm._v(" in 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Unfortunately, owing to domestic circumstances, I have not been able to visit the Regiment in Brunei. However, I have, from time to time over the years, met the 6th Gurkhas and can number among their officers several old friends. I have also visited Nepal and met the Gurkhas in their native habitat. Lieutenant Colonel ‘Tich’ Harvey, Regimental Secretary in his retirement, has been of enormous assistance and it was a pleasure to meet Lieutenant Colonel Nigel Collett who commanded the Regiment from 1991 to 1993,")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I have also to thank General Pett for choosing the illustrations, always a difficult and time-consuming task.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("My GOC in Aden from 1961–63, General Jim Robertson, a 6th Gurkha of 6th Gurkhas, has helped to fill in some of the gaps, as has Brigadier Gil Hickey who organized our unforgettable visit to Nepal 26 years ago. Unfortunately ill-health prevented my meeting with General Pat Patterson, an old friend, and likewise Brigadier Brunny Short. However, I was fortunate enough to have a meeting with John Slim, under whose father I had served in Burma in 1942. Michael Calvert, a friend of many years’ standing, has been kind enough to tell me about the 3/6th who served under him as "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHINDITS")]), _vm._v(" in Burma in 1944 and who covered themselves in glory at Mogaung.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Anne Gonzalez has given me some help on the secretarial side but here my deepest thanks must go to my daughter, Jenny Toyne Sewell, who, despite a terrifyingly busy life, has found the time to type the manuscript in her usual immaculate style and, now and then and from time to time, has corrected my spelling and grammar and improved my punctuation! I am enormously indebted to her.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Finally a word for Lance-Naik Amritbahadur in whatever Gurkha Valhalla he is at present inhabiting. Without his ready aid as my orderly during the retreat from Burma in 1942, I certainly would not have survived to write this book and, to that extent, he must bear some responsibility for what follows. "), _c('em', [_vm._v("Syabas!")])]), _vm._v(" "), _c('p', {
    staticClass: "pararight"
  }, [_vm._v("J. D. L.")])])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b88fea7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/12_acknowledgements.vue
// module id = 87
// module chunks = 0